export default class RadioOpion {
  constructor({ name, value }) {
    this.name = name;
    this.value = value;
  }
}
